var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "assist-fab",
      attrs: { disabled: _vm.disabled },
      on: { click: _vm.handleClick },
    },
    [
      _c("div", { staticClass: "fab-content" }, [
        _c("div", { staticClass: "assist-icon" }, [
          _c("img", {
            attrs: {
              src: _vm.assistIconSrc,
              alt: _vm.$t("manuscriptPage.manuscriptList.assistIconAlt"),
            },
          }),
        ]),
        _c("span", { staticClass: "assist-text" }, [
          _vm._v(_vm._s(_vm.$t("manuscriptPage.manuscriptList.assist"))),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }